import * as React from 'react'
import UsersManagementGrid from "../../components/bo-core/grids/UsersManagementGrid/UsersManagementGrid";

const UsersManagement = () => {
    return (
        <div style={{backgroundColor: '#2D3436', height: '100%'}}>
            <UsersManagementGrid />
        </div>
    )
}
export default UsersManagement;



// WEBPACK FOOTER //
// ./app/views/bo-core/UsersManagement.tsx